module.exports = __webpack_public_path__ + "static/img/pdf3.75a7c14e.png";